import React, { ReactElement } from "react";
import { gql, 
  useMutation 
} from "@apollo/client";
import { GetBalanceMutationMutation } from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

export const getBalanceMutation = gql`
  mutation GetBalanceMutation {
    getBalance {
      errors {
        path
        message
      }
      message
      data {
        currency
        available_balance
        ledger_balance
      }
    }
  }
`;

interface BalanceData {
  currency?: string | null;
  available_balance?: number | null;
  ledger_balance?: number | null;
}

interface Props {
  children: (
    data: {
      submitGetBalance: () => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
      balanceData: BalanceData | null;
    }
  ) => ReactElement | null;
}

export const GetBalanceController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<GetBalanceMutationMutation>(
    getBalanceMutation
  );

  const submitGetBalance = async () => {
    const { data: { getBalance } = {} }: any = await mutate();

    if (getBalance?.errors) {
      return normalizeErrors(getBalance.errors);
    }

    return null;
  };

  const message = data?.getBalance?.message || null;
  const balanceData: BalanceData | null = data?.getBalance?.data || null;

  return children({
    submitGetBalance,
    loading,
    error,
    message,
    balanceData
  });
};
